<template>
  <top-header></top-header>
  <div id="spacer"></div>
  <div id="content" v-if="dataReady">
    <Modal
      :name="aClassName"
      :isClass="true"
      v-show="isModalVisible"
      @close="closeModal"
      @delete1="deleteClass"
    />
    <div v-if="coTeacher">
      <span v-if="oldcode != this.$store.state.user.code">
        <a href="#" class="inactiveclass" @click="switchTeach(this.oldcode)">
          MyClasses
        </a> 
      </span>
      <span v-else>
        <a href="#" class="activeclass" @click="switchTeach(this.oldcode)">
          MyClasses
        </a> 
      </span>    
      <span v-if="oldcode != this.$store.state.user.code"> |
        <a href="#" class="activeclass" @click="switchTeach(this.coTeacher)">
          {{coTeachFirst +' '+coTeachLast}}'s Classes
        </a> |
        <a href="#" class="inactiveclass" @click="removeCoTeach()">
          Remove Co-Teacher
        </a> 
      </span>
      <span v-else> |
        <a href="#" class="inactiveclass" @click="switchTeach(this.coTeacher)">
          {{coTeachFirst +' '+coTeachLast}}'s Classes
        </a> |
        <a href="#" class="inactiveclass" @click="removeCoTeach()">
          Remove Co-Teacher
        </a>  
      </span>
    </div>
    <div v-else>
      <router-link
        :to="{
          name: 'coteacher'
        }"
      >
        Add Co-Teacher
      </router-link>  
    </div>
    
     
    <div v-if="error" class="error">{{ error }}</div>
    <div id="content" v-if="classes.length < 28">
      <form @submit.prevent="pressed">
        <input
          type="text"
          v-model="class_name"
          placeholder="Class Name"
        />&nbsp;&nbsp;
        <n-button @click="handleClick" ghost type="primary" color="blue"
          >Add Class</n-button
        >
      </form>
    </div>

    <div id="content2">
    <table v-if="classes.length != 0">
      <thead>
      <tr>
        <th>Class Name</th>
        <th>Students</th>
        <th>Access Code</th>
        <th>Language</th>
        <th colspan="2" width="40px">&nbsp;</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="aClass in classes" :key="aClass.id">
        <td style="text-align: left;">
          <router-link
            :to="{
              name: 'progress',
              query: { 
                classID: aClass.id,
                class: aClass.name
              }
            }"
          >
            {{ aClass.name }}
          </router-link>       
        </td>
        <td>
          <router-link
            :to="{
              name: 'roster',
              query: {
                classID: aClass.id,
                class: aClass.name,
                language: aClass.language
              }
            }"
          >
            {{ aClass.studs }}
          </router-link>
        </td>
        <td>{{ aClass.code }}</td>
        <td>{{ aClass.language }}</td>
        <td>
          <router-link
            :to="{
              name: 'editclass',
              query: {
                classID: aClass.id,
                class: aClass.name
              }
            }"
          >
            <img alt="Edit" src="../../assets/images/edit_icon.png" />
          </router-link>
        </td>
        <td>
          <a href="#" @click="showModal(aClass.name, aClass.id)">
            <img alt="Delete" src="../../assets/images/trash.png" />
          </a>
        </td>
      </tr>
      </tbody>
    </table>
    </div>
  </div>
  <div id="content" v-else>
    Data loading, please wait...
  </div>
</template>

<script>
import TopHeader from '@/components/Top-Header';
import { db } from '@/firebase';
import { collection, doc, query, where, orderBy, getDocs, addDoc, deleteDoc, updateDoc, deleteField } from 'firebase/firestore';
import Modal from '@/components/Modal.vue';
import { NButton } from 'naive-ui';

export default {
  name: 'ClassesView',
  components: {
    'top-header': TopHeader,
    'n-button': NButton,
    Modal
  },
  data() {
    return {
      error: '',
      dataReady: false,
      classes: [],
      aClassName: '',
      aClassID: '',
      class_name: '',
      isModalVisible: false,
      name: this.$store.state.user.name,
      coTeacher: this.$store.state.user.coteach,
      oldcode: this.$store.state.user.oldcode,
      coTeachFirst: '',
      coTeachLast: ''
    };
  },
  methods: {
    showModal(theClassName, theClassID) {
      this.isModalVisible = true;
      this.aClassName = theClassName;
      this.aClassID = theClassID;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    async deleteClass() {
      this.isModalVisible = false;
      try {
        await deleteDoc(doc(db, 'classes', this.aClassID));
      } catch (err) {
        console.log(err);
        this.error = err;
      }

      try {
        let deleteStuds = await getDocs(query(collection(db, 'users'), where('classID', '==', this.aClassID)));
        for (const aDoc of deleteStuds.docs) {
          await deleteDoc(doc(db, 'users', aDoc.id));
        }

        this.class_name = '';
        this.error = '';
        this.classes = [];
        const classesQ1 = query(collection(db, 'classes'), where('code', '==', this.$store.state.user.code), orderBy('name'));
        let snapshot = await getDocs(classesQ1);
        snapshot.forEach(doc => {
          let numStuds = 0;
          if (doc.data().roster) numStuds = doc.data().roster.length;
          this.classes.push({
            code: doc.data().code,
            name: doc.data().name,
            studs: numStuds,
            id: doc.id,
            language: doc.data().language
          });
        }, this);
      } catch (err) {
        console.log(err);
        this.error = err;
      }
    },
    async switchTeach (theCode) {
      await this.$store.commit('changeCode', theCode);  
      this.class_name = '';
        this.error = '';
        this.classes = [];
        const classesQ2 = query(collection(db, 'classes'), where('code', '==', this.$store.state.user.code), orderBy('name'));
        let snapshot2 = await getDocs(classesQ2);
        snapshot2.forEach(doc => {
          let numStuds = 0;
          if (doc.data().roster) numStuds = doc.data().roster.length;
          this.classes.push({
            code: doc.data().code,
            name: doc.data().name,
            studs: numStuds,
            id: doc.id,
            language: doc.data().language
          });
        }, this);
    },
    async removeCoTeach() {
      try {
        await this.$store.commit('changeCode', this.oldcode);
        await this.$store.commit('changeCoTeach', ''); 
        this.coTeacher = ''; 
        this.coTeachFirst = '';
        this.coTeachLast = '';   
        var uRef = doc(db, 'users', this.$store.state.user.id);
        await updateDoc(uRef, {
          coteach: deleteField()
        });

        this.class_name = '';
        this.error = '';
        this.classes = [];
        const classesQ3 = query(collection(db, 'classes'), where('code', '==', this.$store.state.user.code), orderBy('name'));
        let snapshot3 = await getDocs(classesQ3);
        snapshot3.forEach(doc => {
          let numStuds = 0;
          if (doc.data().roster) numStuds = doc.data().roster.length;
          this.classes.push({
            code: doc.data().code,
            name: doc.data().name,
            studs: numStuds,
            id: doc.id,
            language: doc.data().language
          });
        }, this);
      } catch (err) {
        console.log(err);
        this.error = err;
      }
    },     
    async handleClick() {
      try {
        if (this.class_name.length == 0)
          throw 'Please enter a name for the class';
        if (this.class_name.length > 19)
          throw 'Class name must be less than 20 characters';
        else {
          await addDoc(collection(db, 'classes'), {
            code: this.$store.state.user.code,
            name: this.class_name,
            language: 'English',
            chapters9: [
              {
                chapter: 'Chapter 1',
                active: true
              },
              {
                chapter: 'Chapter 2',
                active: true
              },
              {
                chapter: 'Chapter 3',
                active: true
              },
              {
                chapter: 'Chapter 4',
                active: true
              },
              {
                chapter: 'Chapter 5',
                active: true
              },
              {
                chapter: 'Chapter 6',
                active: true
              },
              {
                chapter: 'Chapter 7',
                active: true
              },
              {
                chapter: 'Chapter 8',
                active: true
              },
              {
                chapter: 'Chapter 9',
                active: true
              }
            ],
            chapters18: [
              {
                chapter: 'Chapter 10',
                active: true
              },
              {
                chapter: 'Chapter 11',
                active: true
              },
              {
                chapter: 'Chapter 12',
                active: true
              },
              {
                chapter: 'Chapter 13',
                active: true
              },
              {
                chapter: 'Chapter 14',
                active: true
              },
              {
                chapter: 'Chapter 15',
                active: true
              },
              {
                chapter: 'Chapter 16',
                active: true
              },
              {
                chapter: 'Chapter 17',
                active: true
              },
              {
                chapter: 'Chapter 18',
                active: true
              }
            ]
          });

          this.class_name = '';
          this.error = '';

          this.classes = [];
          const classesQ4 = query(collection(db, 'classes'), where('code', '==', this.$store.state.user.code), orderBy('name'));
          let snapshot4 = await getDocs(classesQ4);
          snapshot4.forEach(doc => {
            let numStuds = 0;
            if (doc.data().roster) numStuds = doc.data().roster.length;
            this.classes.push({
              code: doc.data().code,
              name: doc.data().name,
              studs: numStuds,
              id: doc.id,
              language: doc.data().language
            });
          }, this);
        }
      } catch (err) {
        console.log(err);
        this.error = err;
      }
    }
  },
  async mounted() {
    try {
      const classesQ5 = query(collection(db, 'classes'), where('code', '==', this.$store.state.user.code), orderBy('name'));
      let snapshot = await getDocs(classesQ5);
      snapshot.forEach(doc => {
        let numStuds = 0;
        if (doc.data().roster) numStuds = doc.data().roster.length;
        this.classes.push({
          code: doc.data().code,
          name: doc.data().name,
          studs: numStuds,
          id: doc.id,
          language: doc.data().language
        });
      }, this);   
    
      const teacherQ = query(
        collection(db, 'users'),
        where('code', '==', this.coTeacher),
        where('teacher', '==', 'y')
      );
      const teachSnap = await getDocs(teacherQ);
      if(teachSnap.empty)
        throw 'No co-teacher';
      teachSnap.forEach(doc => {
        this.coTeachFirst = doc.data().name;
        if(doc.data().last_name)
          this.coTeachLast = doc.data().last_name;
      });

    } catch (err) {
      console.log(err);
    }
    this.dataReady = true;
  }
};
</script>

<style scoped>
#spacer {
  height: 90px;
}

#content {
  text-align: center;
  margin: auto;
  padding: 10px;
  font-size: 18px;
  max-width: 1150px;
}

#content2 {
  text-align: center;
  margin: auto;
  padding: 0px;
  font-size: 18px;
  height:500px;
  max-width:900px;
  overflow:auto;
}

#title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin: auto;
  padding: 5px;
}

table {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  border: 1px solid black;
  border-spacing: 5px;
  text-align: center;
  border-collapse: collapse;
  background-color: #afdafd;
}

td {
  border: 1px solid #dddddd;
  text-align: center;
  padding: 6px;
}

th {
  top:0;
  border: 1px solid #dddddd;
  text-align: center;
  padding: 8px;
  background-color: #52b1ff;
  position: sticky;
}

tr:nth-child(even) {
  background-color: #dddddd;
}

ul {
  margin: 0 auto;
}

.error {
  color: red;
  font-size: 18px;
  margin-bottom: 0px;
}

select,
input {
  width: 300px;
  padding: 5px;
  margin: 5px;
  font-size: 18px;
}
button {
  width: 150px;
  height: 35px;
  font-size: 18px;
}

a {
  color: blue;
  padding: 5px 10px;
  text-align: center;
  text-decoration: underline;
  font-size: 18px;
}

a.activeclass {
  color: black;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
}

a.activeclass:hover {
  color: black;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  font-size: 18px;
}

a.inactiveclass {
  color: rgb(109, 109, 109);
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  font-size: 18px;
}

a.inactiveclass:hover {
  color: blue;
  padding: 5px 10px;
  text-align: center;
  text-decoration: underline;
  font-size: 18px;
}

a:hover,
a.router-link-exact-active {
  font-size: 18px;
  color: blue;
  text-decoration: underline;
}
</style>
